import { api } from './api'

export interface AppNotification {
  id: string
  type: string
  title: string
  body: string | null
  link: string | null
  read_at: string | null
  created_at: string
}

export const notificationApi = {
  list: (unreadOnly = false) =>
    api.get<{ items: AppNotification[]; total: number }>('/v1/notifications', { params: { unread_only: unreadOnly } }).then((r) => r.data),
  unreadCount: () => api.get<{ count: number }>('/v1/notifications/unread-count').then((r) => r.data.count),
  markRead: (id: string) => api.post(`/v1/notifications/${id}/read`).then((r) => r.data),
  /** Marks only `ids` (what the user was shown), never unseen older ones. */
  markAllRead: (ids: string[]) =>
    api.post<{ status: string; marked: number }>('/v1/notifications/read-all', { ids }).then((r) => r.data),
}
